import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyDeIt5_4FOsAC-Ku0oUF83nM2q8bgeaWqE",
  authDomain: "content-manager-cfa42.firebaseapp.com",
  projectId: "content-manager-cfa42",
  storageBucket: "content-manager-cfa42.appspot.com",
  messagingSenderId: "772644439539",
  appId: "1:772644439539:web:391e8a1e8019ccc4acfe86"
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

const firebaseAuth = getAuth(firebaseApp);
const firebaseDB = getFirestore(firebaseApp);
const firebaseFunctions = getFunctions(firebaseApp);

export { firebaseAuth, firebaseDB, firebaseFunctions };
